/*
 * @Author: yeyimei
 * @Date: 2023-06-20 16:29:48
 * @LastEditTime: 2025-05-21 11:49:25
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\router\pointsmall.routes.js
 */
export default [
  {
    path: '/points-mall/home',
    name: 'pointsmall',
    component: () => import('@/views/points-mall/index.vue'),
    meta: {
      title: '绿色积分中心',
      showName: true,
    },
  },
  {
    path: '/points-mall/record',
    name: 'pointsRecord',
    component: () => import('@/views/points-mall/points-record.vue'),
    meta: {
      title: '绿色积分记录',
      showName: true,
    },
  },
  {
    path: '/points-mall/exchange',
    name: 'pointsXchange',
    component: () => import('@/views/points-mall/points-exchange.vue'),
    meta: {
      title: '绿色积分兑换',
      showName: true,
    },
  },
  {
    path: '/points-mall/myvoucher',
    name: 'pointsMyvoucher',
    component: () => import('@/views/points-mall/my-voucher.vue'),
    meta: {
      title: '卡券中心',
      showName: true,
    },
  },
  {
    path: '/consumption-voucher',
    name: 'consumptionVoucher',
    component: () => import('@/views/consumption-voucher/index.vue'),
    meta: {
      title: '消费券',
      showName: true,
    },
  },
  {
    path: '/points-mall/rule',
    name: 'pointsRule',
    component: () => import('@/views/points-mall/points-rule.vue'),
    meta: {
      title: '绿色积分规则',
      showName: true,
    },
  },
]
